module.exports = __webpack_public_path__ + "static/media/humanFigureMale.ff9943ce.png";